export const DrawOptions = {
    tooltips: true,
    allowSelfIntersection: true,
    templineStyle: { color: 'orange' },
    hintlineStyle: { color: 'orange' },
    pathOptions: {
        // add leaflet options for polylines/polygons
        color: 'orange',
        fillColor: 'orange'
    }
};

export const DrawOptionsRed = {
    tooltips: true,
    allowSelfIntersection: true,
    templineStyle: { color: 'red' },
    hintlineStyle: { color: 'red' },
    pathOptions: {
        // add leaflet options for polylines/polygons
        color: 'red',
        fillColor: 'red'
    }
};

export const DrawStopOptions = {
    tooltips: true,
    allowSelfIntersection: false,
    templineStyle: { color: 'red' },
    hintlineStyle: { color: 'red' },
    pathOptions: {
        // add leaflet options for polylines/polygons
        color: 'red',
        fillColor: 'red'
    }
};